import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import {
    ReducersConfigurator,
    EffectsConfigurator,
    ReducersRepository,
    EffectsRepository,
    ReducerConfiguration,
    EffectsConfiguration,
    Selector
} from './internals/index';

import { StateConfig } from './state-config';


export class State {

    private _store: Store < any > ;
    private _reducersConfigurator: ReducersConfigurator;
    private _reducersRepository: ReducersRepository;
    private _effectsConfigurator: EffectsConfigurator;
    private _effectsRepository: EffectsRepository;

    constructor(
        store: Store < any > ,
        reducersConfigurator: ReducersConfigurator,
        effectsConfigurator: EffectsConfigurator,
        reducersRepository: ReducersRepository,
        effectsRepository: EffectsRepository
    ) {

        this._store = store;
        this._reducersConfigurator = reducersConfigurator;
        this._effectsConfigurator = effectsConfigurator;
        this._reducersRepository = reducersRepository;
        this._effectsRepository = effectsRepository;
    }

    public configure(config: StateConfig): void {

        if (config.state) {
            this.configureReducers(config.state);
        }

        if (config.effects) {
            this.configureEffects(config.effects);
        }
    }

    public configureReducers(config: ReducerConfiguration): void {
        this._reducersConfigurator.addReducers(config);
    }

    public configureEffects(config: EffectsConfiguration): void {
        this._effectsConfigurator.addEffects(config);
    }

    public addReducerHandlers(reducersMap: any): void {
        this._reducersRepository.addByMap(reducersMap);
    }

    public addEffectHandlers(effectsMap: any): void {
        this._effectsRepository.addByMap(effectsMap);
    }

    public dispatch(type: string, payload?: any): void {
        this._store.dispatch({
            type: type,
            payload: payload
        });
    }

    public select(path: string): Observable < any > {
        return this._store.pipe(
            Selector.selectByPath(path)
        );
    }
}
